import { Switch } from '@headlessui/react';
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import SelectInput from "../../../../../components/forms/select";
import { stmSlotCreateRequest } from "../../../../../redux/journey-toolbox/journey-toolbox-actions";
import { HiPlus } from 'react-icons/hi';

const getAutoFillFromEntity = autoFillFromEntity => {
  return (autoFillFromEntity === undefined || autoFillFromEntity === null) ? true : autoFillFromEntity;
}

function Page({ value, autoFillFromEntity, slots = {}, onChange, title = 'Variable', slotCreatRequest, showCaptureFromUserInput = true }) {
  console.log('slots', slots)
  const [valueSt, setValueSt] = useState(value || '');
  const [valueAutoFillFromEntity, setValueAutoFillFromEntity] = useState(getAutoFillFromEntity(autoFillFromEntity));
  const [search, setSearch] = useState('');

  useEffect(() => {
    setValueSt(value);
  }, [value]);

  useEffect(() => {
    setValueAutoFillFromEntity(getAutoFillFromEntity(autoFillFromEntity));
  }, [autoFillFromEntity]);

  const isEntityTypeSlot = () => {
    // return !!(valueSt && slots[valueSt] && slots[valueSt].captureFromUserInput);
    // slot always captureFromUserInput
    return true
  }

  const filteredSortedSlotNames = (() => {
    const q = (search || '').toLowerCase();
    return Object.keys(slots)
      .filter((slotName) => {
        const label = (slots[slotName]?.displayText || slotName).toLowerCase();
        return q ? label.includes(q) : true;
      })
      .sort((a, b) => {
        const la = (slots[a]?.displayText || a).toLowerCase();
        const lb = (slots[b]?.displayText || b).toLowerCase();
        if (la < lb) return -1;
        if (la > lb) return 1;
        return 0;
      });
  })();

  return (
    <div className="space-y-4 pt-3">
      <div className="relative">
        <div className="absolute top-0 right-0 z-10">
          <button onClick={slotCreatRequest} className="text-sm inline-flex gap-2 items-center text-blue-700 font-semibold">
            <HiPlus />
            Create Variable
          </button>
        </div>
        {/* <div className="mb-2">
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search Variable"
            className="block w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm shadow-sm focus:border-blue-500 focus:ring-blue-500"
          />
        </div> */}
        <SelectInput
          label={title}
          id="slot"
          name="slot"
          autoComplete="slot"
          value={valueSt}
          onChange={event => {
            console.log("slot select", event.target.value)
            onChange({ target: { name: 'slot', value: event.target.value } })
          }}
          optionsComp={<>
            {valueSt ?
              <option value="">Unselect Variable</option>
              :
              <option value="">Select Variable</option>
            }
            {filteredSortedSlotNames.map((slotName, si) => (
              <option key={si} value={slotName}>{slots[slotName].displayText || slotName}</option>
            ))}
          </>}
        />
      </div>
      {(showCaptureFromUserInput && isEntityTypeSlot()) &&
        <div className="flex flex-row justify-between items-center">
          <label htmlFor="slot" className="block mb-2 text-sm font-medium text-gray-900">
            Capture from user input
          </label>
          <Switch
            checked={valueAutoFillFromEntity}
            onChange={val => onChange({ target: { name: 'autoFillFromEntity', value: val } })}
            className={`${valueAutoFillFromEntity ? 'bg-blue-600' : 'bg-gray-200'
              } relative inline-flex h-6 w-11 items-center rounded-full`}
          >
            <span className="sr-only">Auto Fill</span>
            <span
              className={`${valueAutoFillFromEntity ? 'translate-x-6' : 'translate-x-1'
                } inline-block h-4 w-4 transform rounded-full bg-white transition`}
            />
          </Switch>
        </div>
      }
    </div>

  )
}
const mapsStateToProps = (state, ownProps) => {
  return {
  };
}

const mapDispatchToProps = dispatch => {
  return {
    slotCreatRequest: () => {
      dispatch(stmSlotCreateRequest());
    },
  };
}

export default connect(mapsStateToProps, mapDispatchToProps)(Page)